"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeacherEntryUpdateData = void 0;
const utils_1 = require("../../utils");
const lodash_1 = require("lodash");
var TeacherEntryUpdateData;
(function (TeacherEntryUpdateData) {
    function updateFields(data) {
        const fields = {};
        const now = Date.now();
        (0, lodash_1.forEach)(data.pinEntries, (pinEntry) => {
            const pinId = pinEntry.pinId;
            fields[`entries.${pinId}.pinId`] = pinEntry.pinId;
            // todo: apply words array
            updateProperty(fields, `entries.${pinId}.words`, pinEntry.words);
        });
        if (data.removeAllPinEntries) {
            fields[`entries`] = {};
        }
        (0, lodash_1.forEach)(data.removeEntriesPinIds, (pinId) => (fields[`entries.${pinId}`] = null));
        const cleaned = (0, utils_1.omitDeepUndefined)(fields);
        if (!(0, lodash_1.isEmpty)(cleaned)) {
            cleaned['modifiedAt'] = now;
        }
        return cleaned;
    }
    TeacherEntryUpdateData.updateFields = updateFields;
})(TeacherEntryUpdateData || (exports.TeacherEntryUpdateData = TeacherEntryUpdateData = {}));
/** helper for setting the property, when the value is null. it will delete the field */
function updateProperty(updateFields, field, value) {
    if ((0, lodash_1.isNull)(value)) {
        updateFields[field] = null;
    }
    else if (!(0, lodash_1.isNil)(value)) {
        updateFields[field] = value;
    }
}
//# sourceMappingURL=TeacherEntryUpdateData.js.map